import { VideoTrackType as _VideoTrackType } from './types'

export const VideoType = {
  VideoTrackType: _VideoTrackType
}
export { VideoTrackType } from './types'
export { default } from './Video'
